import { Box, Button, Checkbox, Divider, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { ReactComponent as IconArrowDown } from 'assets/img/icons/arrow-down.svg';
import { globalStyles } from 'theme/styles';
import { ReactComponent as IconReturnFund } from 'assets/img/icons/return-fund.svg';
import CardStatusView, { CardStatus } from 'components/dataDisplay/CardStatusView';

export default function DepositHistoryRow(props: { data: any, onReturnFund: (data: any) => void, isLastCell?: boolean }) {

	const { data, onReturnFund, isLastCell } = props;
	const textColor = useColorModeValue('gray.100', 'darkGray.100');

	return (
		<>
			<Flex direction={'row'} alignItems='center' minH='44px' justifyContent='space-around' padding={'0 0 0 30px'}>
				<Flex h='100%' justifyContent={'flex-start'} alignItems={'center'} flex={1}>
					<Text color={textColor} fontSize={'16px'}>
						{data.effectiveDate}
					</Text>
				</Flex>
				<Flex h='100%' justifyContent={'flex-start'} alignItems={'center'} flex={1}>
					<Text color={textColor} fontSize={'16px'}>
						{data.card.clientId}
					</Text>
				</Flex>
				<Flex h='100%' justifyContent={'flex-start'} alignItems={'center'} flex={2}>
					<Text color={globalStyles.colors.primary[100]} fontSize={'16px'} textDecoration='underline'>
						{data.card.cardHolder}
					</Text>
				</Flex>
				<Flex h='100%' justifyContent={'flex-start'} alignItems={'center'} flex={1}>
					<Text color={textColor} fontSize={'16px'}>
						${data.amount / 100}
					</Text>
				</Flex>
				<Flex h='100%' justifyContent={'flex-start'} alignItems={'center'} flex={1}>
					<Text color={textColor} fontSize={'16px'}>
						{data.transactionType}
					</Text>
				</Flex>
				<Flex h='100%' justifyContent={'flex-start'} alignItems={'center'} flex={1} direction='row'>
					<Button onClick={() => onReturnFund(data)} leftIcon={<IconReturnFund />} fontSize={'14px'} fontWeight='bold' variant="ghost" borderRadius={'30px'} colorScheme='blue'>
						Return Fund
					</Button>
				</Flex>
			</Flex>
			{!isLastCell && <Divider variant="dashed" />}
		</>
	);
}
